import { Controller } from '@hotwired/stimulus'
import ScrollBooster from 'scrollbooster';

export default class extends Controller {
  static targets = ['viewport', 'content']

  connect () {
    new ScrollBooster({
      viewport: this.viewportTarget,
      content: this.contentTarget,
      direction: 'horizontal',
      scrollMode: 'transform',
      bounce: false,
      friction: 0.05
    })
  }
}
